const PaymentOperator = {
    STRIPE: "stripe",
    MERCADO_PAGO_PIX: "mercadopagopix",
    MERCADO_PAGO: "mercadopago",
    PAGAR_ME: "pagarme",
};

PaymentOperator.contains = (str) => {
    return Object.values(PaymentOperator).includes(str);
};

Object.freeze(PaymentOperator);

module.exports = PaymentOperator;